<div #fileContainer [ngClass]="{'fileAttachmentControlContainer': isEditable, 'fileAttachmentControlContainer-fix': !isEditable, 'invalid': isInvalid, 'disabled': isDisabled}">
  <div class="container-loader" *ngIf="isBusy">
    <ngx-loading [show]="isBusy" [config]="loaderConfig"></ngx-loading>
  </div>
  <div *ngIf="isOptional && isEditable" class="optional-container">
    <mat-checkbox #checkbox
    [attr.name]="propertyName"
    (change)="optionalFileToggle($event)"
    [checked]="isNotApplicable"></mat-checkbox>
    <p *ngIf="checkbox.checked" class="optional-cb-label">Not applicable</p>
  </div>
  <file-drop (onFileDrop)="dropped($event)" (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)">
    <div *ngIf="isEditable" class="text-center fileAttachmentControl">
      <div [ngClass]="{'browse-button': true, 'hide': isUploading}">
        <label for="{{propertyId}}" class="fileButtonAttach">
          Browse
        </label> or Drop file{{ attachmentIsMultiple ? 's' : '' }} to attach
      </div>
      <p class="file-desc">Maximum file upload size is <span class="bold-text">{{maxFileSizeKb / 1024}} MB</span></p>
      <p class="file-desc">Allowed file types: <span class="bold-text">{{allowedFormatsString}}</span></p>
      <!-- <img src="../../assets/images/lazyload.gif" width="15" height="15" [ngClass]="{'upload-loading' : true, 'show': isUploading }"/> -->
      <p [ngClass]="{'upload-loading' : true, 'show': isUploading }">Processing file</p>
      <input #file type="file" (change)="onFileChange($event)" id="{{propertyId}}" placeholder="Select a file" class="fileAttachment" 
      accept="{{acceptFormatString}}"
      [multiple]="attachmentIsMultiple ? 'multiple' : null" hidden/>
      <p *ngIf="errorMessage && !isUploading" class="file-error-message">{{errorMessage}}</p>
    </div>
  </file-drop>
  <div class="fileList-container">
    <div [ngClass]="{'file-list': isEditable, 'file-list-fix': !isEditable, 'has-item': fileList.length > 1}">
      <!-- <img src="../../assets/images/lazyload.gif" width="15" height="15"/> Loading List -->
      <ng-container *ngIf="fileList.length > 0; else noItems">
        <div *ngFor="let file of fileList;index as i; let $last=last" class="attachmentListItemContainer" [class.no-editable]="!isEditable" [class.last]="$last">
          <div class="attachmentDetailsFirstPanel">
            <img [ngClass]="{'loading-file': true, 'show': file.AttachmentId == isFileChange }" src="../../assets/images/lazyload.gif" width="15" height="15">
            <a id="download_{{i}}" [ngClass]="{'attachmentListItem overflow' : true, 'hide': file.AttachmentId == isFileChange}" href="#" 
            [title]="file.AttachmentName" (click)="requestDownloadFile(file)">{{ file.AttachmentName }}</a>
          </div>
          <div [ngClass]="{'attachmentDetailsSecondPanel': true, 'view': !isEditable, 'hide': file.AttachmentId == currentFileId || file.AttachmentId == isFileChange}">
            <span *ngIf="file.AttachmentSizeInBytes">({{ file.AttachmentSizeInBytes | fileSize }})</span>
          </div>
          <div class="attachmentDetailsThirdPanel" *ngIf="isEditable">
            <div [ngClass]="{'fileAttachmentAction': true, 'hide': file.AttachmentId == currentFileId || file.AttachmentId == isFileChange }" (click)="deleteFile(file.AttachmentId)" title="Remove">
              <mat-icon>delete</mat-icon>
            </div>
            <input type="button"
            [ngClass]="{'fileAttachmentDelete': true, 'show': file.AttachmentId == currentFileId && !onBlur}" 
            (click)="deleteConfirmed(file.AttachmentId);" width="60" height="20" value="Confirm?">
          </div>
          <div class="clearfix"></div>
        </div>
      </ng-container>
      <ng-template #noItems>
        <div class="attachmentListItemContainer">
          <span [ngClass]="{'noItems':true, 'hide': isFileChange }">No items found</span>
          <img [ngClass]="{'loading-file': true, 'show': isFileChange }" src="../../assets/images/lazyload.gif" width="15" height="15">
        </div>
      </ng-template>
    </div>
  </div>
  
  <div *ngIf="fileList.length > 1 && isEditable" class="attachmentDeletePanel">
    <button [ngClass]="{'delete-all': true }" (click)="deleteAll()" type="button">
      Delete all
      <mat-icon>delete</mat-icon>
    </button>
    <button [ngClass]="{'delete-all': true }" (click)="downloadAll()" type="button">
      Download all
      <mat-icon>file_download</mat-icon>
    </button>
    <!-- <input type="button"
    [ngClass]="{'fileAttachmentDelete': true, 'show': isDeleteAll && !onBlur}" 
    (click)="deleteAllConfirmed();" width="60" height="20" value="Confirm?"> -->
    <div class="clearfix"></div>
  </div>
</div>